import React, { useState } from 'react'
import { toast } from 'react-toastify'
import { get } from 'services/api'
import PropTypes from "prop-types"
import { useSelector } from "react-redux"
import { Button } from "../index"
import { REPORT_TYPE, REPORT_TYPE_TO_ENDPOINT_MAP } from "../../utils/constants/reportType"

/**
 * ExportButton Component
 *
 * A reusable React component for exporting data with a provided URL and search parameters.
 *
 * @param {Object} props - The component props.
 * @param {string} props.reportType - The URL to make the export request.
 * @param {Object} props.searchParams - The search parameters for the export request.
 * @param {Function} props.setExportRequested - A function to set the export request status.
 * @param {string} [props.buttonText="Export"] - The text to display on the export button.
 * @param {boolean} [props.disabled=false] - A flag to disable the export button.
 *
 * @returns {JSX.Element} The ExportButton component.
 */
const ExportButton = (props) => {
  const [exportLoading, setExportLoading] = useState(false)
  const token = useSelector((state) => state.auth.access_token)
  const {
    reportType,
    searchParams,
    setExportRequested,
    buttonText,
    disabled,
  } = props

  const url = REPORT_TYPE_TO_ENDPOINT_MAP[reportType]

  const handleExport = () => {
    setExportLoading(true)
    get({
      url,
      token,
      params: searchParams,
    })
      .then((response) => {
        if (response.status === 200) {
          toast.success(response.data)
          setExportRequested(true)
        } else {
          toast.error('Erro na exportação, por favor tente novamente.')
        }
      })
      .catch((error) => {
        reportError(error)
        toast.error('Erro na exportação, por favor tente novamente')
      })
      .finally(() => {
        setExportLoading(false)
      })
  }

  return (
    <Button loading={exportLoading} onClick={handleExport} disabled={disabled}>
      {buttonText}
    </Button>
  )
}

ExportButton.propTypes = {
  reportType: PropTypes.oneOf(Object.values(REPORT_TYPE)).isRequired,
  searchParams: PropTypes.object.isRequired,
  buttonText: PropTypes.string,
  disabled: PropTypes.bool,
  setExportRequested: PropTypes.func.isRequired,
}

ExportButton.defaultProps = {
  buttonText: 'Exportar',
  disabled: false,
}

export default ExportButton
